// Normalize inconsistent module names to canonical keys used in gating/UI
// Canonical set: Core, HRM, CRM, Scheduling, Payroll, NDIS, Invoicing, Incidents, Recruitment, Referral, Reports, Policy, Support Coordination, Documents, E-Sign, Messaging

const ALIASES = {
  core: 'Core',
  hr: 'HRM',
  hrm: 'HRM',
  humanresources: 'HRM',
  crm: 'CRM',
  scheduling: 'Scheduling',
  roster: 'Scheduling',
  rostering: 'Scheduling',
  oncall: 'OnCall',
  'on-call': 'OnCall',
  'on call': 'OnCall',
  payroll: 'Payroll',
  ndis: 'NDIS',
  invoicing: 'Invoicing',
  billing: 'Invoicing',
  incidents: 'Incidents',
  incident: 'Incidents',
  recruitment: 'Recruitment',
  'recruitment & ats': 'Recruitment',
  ats: 'Recruitment',
  referral: 'Referral',
  referrals: 'Referral',
  'reference': 'Referral',
  'reference check': 'Referral',
  'reference checks': 'Referral',
  analytics: 'Reports',
  reports: 'Reports',
  reporting: 'Reports',
  policy: 'Policy',
  policies: 'Policy',
  'support coordination': 'Support Coordination',
  'support-coordination': 'Support Coordination',
  sc: 'Support Coordination',
  sc_employeeaccess: 'SC_EmployeeAccess',
  'sc employee access': 'SC_EmployeeAccess',
  'e-sign': 'E-Sign',
  esign: 'E-Sign',
  esignature: 'E-Sign',
  messaging: 'Messaging',
  'mobile app': 'Mobile App',
  mobile: 'Mobile App'
};

export function normalizeModuleName(name) {
  if (!name || typeof name !== 'string') return name;
  const key = name.trim().toLowerCase();
  return ALIASES[key] || name;
}

export function normalizeModulesList(modules) {
  if (!Array.isArray(modules)) return [];
  const set = new Set();
  modules.forEach((m) => {
    const nm = normalizeModuleName(m);
    if (nm) set.add(nm);
  });
  return Array.from(set);
}
